import { useScrollVisible } from "./useScrollVisible";

export function Learning() {
  const { ref, visible } = useScrollVisible(0.15);

  return (
    <section id="lernen" className="relative py-24 md:py-32 bg-sand-50">
      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-[1fr_1.3fr] gap-12 md:gap-20 items-center">
          {/* Accent / stat */}
          <div
            className={`transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-px bg-sage-700" />
              <span className="text-sage-700 text-[11px] tracking-[0.35em] uppercase font-medium">
                Lernen
              </span>
            </div>
            <div className="relative bg-sand-100 rounded-[2rem] p-10 border border-stone-800/8">
              <p className="font-display text-6xl md:text-7xl text-sage-700 font-semibold leading-none">
                20<span className="text-terra-500">+</span>
              </p>
              <p className="mt-3 text-stone-900 font-medium">Jahre Erfahrung</p>
              <p className="mt-1 text-stone-700 text-sm font-light leading-relaxed">
                als Grundschullehrerin und in der Kooperation mit dem Kindergarten.
              </p>
            </div>
          </div>

          <div
            className={`transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <h2 className="font-display text-4xl md:text-5xl text-stone-900 leading-[1.08] tracking-tight font-semibold mb-8">
              Chancen im Bereich Lernen.
            </h2>
            <div className="space-y-5 text-stone-700 leading-relaxed font-light text-base">
              <p>
                In über 20 Jahren Erfahrung als Grundschullehrerin und in der Kooperation
                mit dem Kindergarten begegnen mir täglich Kinder mit Lernschwierigkeiten,
                Verhaltensauffälligkeiten und Koordinationsproblemen. Auch aus diesem
                Grund machte ich die Ausbildung zur pädagogischen Kinesiologin.
              </p>
              <p>
                Über den Muskeltest werden Rückfragen gestellt, Lernblockaden ausfindig
                gemacht und der gespeicherte Stress bearbeitet. Die Integration
                frühkindlicher Reflexe oder Übungen aus <span className="text-stone-900 font-medium">„Brain Gym"</span> können
                helfen, die Lernfähigkeit und damit die Lebensqualität zu verbessern.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
